/**
 * Protected routes already have a session after login. A background
 * getCurrentUser() refresh must not unmount the dashboard, or the page
 * remounts, refetches, and rate-limits itself.
 */
export function shouldShowProtectedRouteSpinner({
  hasInitialized,
  isCheckingAuth,
  isLoading,
  status,
  hasToken,
  hasUser,
}: {
  hasInitialized: boolean;
  isCheckingAuth: boolean;
  isLoading: boolean;
  status: string;
  hasToken: boolean;
  hasUser: boolean;
}): boolean {
  if (hasToken && hasUser) return false;
  return !hasInitialized || isCheckingAuth || isLoading || status === 'loading';
}
